import { CrudService, Meta } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UnidadeNegocioEntity } from "@catalogo/models";
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import {UsuarioUnidadeNegocioEntity} from "@catalogo/models/operacional";

@Injectable({ providedIn: 'root' })
export class UnidadeNegocioDataService extends CrudService<UnidadeNegocioEntity>
{
    protected url: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        protected httpClient: HttpClient
    )
    {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/unidadenegocio`;
    }

    public obterUsuarios = (id: string, meta: Meta) =>
        this.getWithQueryBase<UsuarioUnidadeNegocioEntity>(`${this.url}/${id}/Usuario`, meta);
}
